import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './App'
import './index.css'
import {redirectPastedDeepLinkToNewPortal} from './lib/portal-migration/redirect-pasted-event-deep-link'

if (!redirectPastedDeepLinkToNewPortal()) {
  const container = document.getElementById('root')
  const root = createRoot(container!)
  root.render(
    <React.StrictMode>
      <div>
        <App />
      </div>
    </React.StrictMode>,
  )
}
